import { AbstractControl, ValidationErrors } from '@angular/forms';

/** 9 dígitos, com hífen opcional após o 5º (máscara do campo). Ex.: 99999-8888 */
const CELULAR_REGEX = /^\d{5}-?\d{4}$/;

/**
 * Valida o celular sem DDD (9 dígitos).
 * Campo vazio é considerado válido — quem cobra o preenchimento é o Validators.required.
 */
export function celularValidator(control: AbstractControl<string>): ValidationErrors | null {
  const celular = (control.value ?? '').trim();

  if (!celular) {
    return null;
  }

  return CELULAR_REGEX.test(celular) ? null : { celular: true };
}
